import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '@/lib/api';

const AuthCtx = createContext({ token: null, user: null, ready: false, login: () => {}, logout: () => {} });

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('verse_token') || null);
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    const load = async (attempt = 0) => {
      if (!token) { setReady(true); return; }
      try {
        const { data } = await api.get('/auth/me');
        if (data.access_token) { localStorage.setItem('verse_token', data.access_token); delete data.access_token; }
        if (active) setUser(data);
      } catch (e) {
        // Only a real sign-out (401) ends the session; network blips and server restarts keep you signed in.
        if (active && e?.response?.status === 401) { setToken(null); localStorage.removeItem('verse_token'); }
        else if (active && attempt < 5) setTimeout(() => active && load(attempt + 1), 5000);
      } finally {
        if (active) setReady(true);
      }
    };
    load();
    return () => { active = false; };
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('verse_token', data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    const t = localStorage.getItem('verse_token');
    if (t) api.post('/auth/logout', null, { headers: { Authorization: `Bearer ${t}` } }).catch(() => {});
    localStorage.removeItem('verse_token');
    localStorage.removeItem('verse.threads.v1');  // saved Inbox chats stay with the signed-in person
    setToken(null); setUser(null);
  };

  return <AuthCtx.Provider value={{ token, user, ready, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
